import React, { useState } from "react";
import { Container, Img, Link, ModalWrap, Title, Wrapper } from "./style";
import Ecommerce from "../../assets/imgs/blogpost.png";
import ExpenseTracking from "../../assets/imgs/expense-traceker.png";
import TaskManager from "../../assets/imgs/task-manager.png";
import Lists from "../../assets/imgs/lists.png";
import TicTacToe from "../../assets/imgs/tic-tac-toe.png";
import Weather from "../../assets/imgs/weather.png";
import Fetch from "../../assets/imgs/fetch.png";
import CaterWay from "../../assets/imgs/caterway.png";
import Albarakah from "../../assets/imgs/albarakah.png";
import { Button as Buttons } from "../About/style";
import { Modal, Button } from "antd";
import "antd/dist/antd.css";
export default function Services() {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible1, setModalVisible1] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);
  const [modalVisible3, setModalVisible3] = useState(false);
  const [modalVisible4, setModalVisible4] = useState(false);
  const [modalVisible5, setModalVisible5] = useState(false);
  const [modalVisible6, setModalVisible6] = useState(false);
  const [modalVisible7, setModalVisible7] = useState(false);

  // const history = useHistory();
  // const onClick = () => {
  //   window.location = "/https://github.com/kholdarboev?tab=repositories";
  // };
  return (
    <Container title reveal>
      <Title main>My Work</Title>
      <Title range />
      <Wrapper content>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible}
              onOk={() => setModalVisible(false)}
              onCancel={() => setModalVisible(false)}
            >
              <ModalWrap>
                <h1
                  className="modaltitle"
                  style={{ marginTop: "100px", fontWeight: "700", fontSize: "45px" }}
                >
                  Housing Real estate
                </h1>
                <Img modal src={Lists} />
                <ul>
                  <li>Designed frontend by using styled-Components, AntDesign</li>
                  <li>
                    Crafted fully responsive, dynamic system with flat application design powered by
                    JavaScript React, HTML5, styled-components, compatible across 100% of modern
                    browsers.
                  </li>
                  <li>Fetched with useQuery from swagger</li>
                </ul>
                <div>
                  <Link href="https://houzin.netlify.app/" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/sf_houzing" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>

            <Img src={Lists} onClick={() => setModalVisible(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible1}
              onOk={() => setModalVisible1(false)}
              onCancel={() => setModalVisible1(false)}
            >
              <ModalWrap>
                <h1 className="modaltitle" style={{ fontWeight: "700", fontSize: "45px" }}>
                  Food ordering
                </h1>
                <Img modal src={Albarakah} />
                <ul>
                  <li>Designed frontend by using, CSS3, styled-Components, MaterialUI</li>
                  <li>Deployed on Netlify</li>
                </ul>
                <div>
                  <Link href="https://albarakaah.com/" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/uzFood" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>
            <Img src={Albarakah} onClick={() => setModalVisible1(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible2}
              onOk={() => setModalVisible2(false)}
              onCancel={() => setModalVisible2(false)}
            >
              <ModalWrap>
                <h1 className="modaltitle" style={{ fontWeight: "700", fontSize: "45px" }}>
                  Weather App
                </h1>
                <Img modal src={Weather} />
                <ul>
                  <li>Fahrenheit and Celsius </li>
                  <li>Built backend using OpenWeather API for fetching live weather forecast.</li>
                </ul>
                <div>
                  <Link href="https://weather-app-sf.netlify.app/" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/weatherapp" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>
            <Img src={Weather} onClick={() => setModalVisible2(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible3}
              onOk={() => setModalVisible3(false)}
              onCancel={() => setModalVisible3(false)}
            >
              <ModalWrap>
                <h1 className="modaltitle" style={{ fontWeight: "700", fontSize: "45px" }}>
                  Task Manager
                </h1>
                <Img modal src={TaskManager} />
                <ul>
                  <li>Designed ReactJS website with HTML5, CSS3 and JavaScript.</li>
                  <li>Built using ContextAPI to develop CRUD app</li>
                  <li>deployed using Netlify</li>
                </ul>
                <div>
                  <Link href="https://task-managing.netlify.app" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/Task-Manager" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>
            <Img src={TaskManager} onClick={() => setModalVisible3(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible4}
              onOk={() => setModalVisible4(false)}
              onCancel={() => setModalVisible4(false)}
            >
              <ModalWrap>
                <h1 className="modaltitle" style={{ fontWeight: "700", fontSize: "45px" }}>
                  Tic Tac Toe
                </h1>
                <Img modal src={TicTacToe} />
                <ul>
                  <li>Built backend using OpenWeather API for fetching live weather forecast.</li>
                </ul>
                <div>
                  <Link href="https://tictactoe-uz.netlify.app" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/sf_houzing" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>
            <Img src={TicTacToe} onClick={() => setModalVisible4(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible5}
              onOk={() => setModalVisible5(false)}
              onCancel={() => setModalVisible5(false)}
            >
              <ModalWrap>
                <h1 className="modaltitle" style={{ fontWeight: "700", fontSize: "45px" }}>
                  Ordering food
                </h1>
                <Img modal src={Ecommerce} />
                <ul>
                  <li>Developed simple application where to get all </li>
                </ul>
                <div>
                  <Link href="https://uzfood.netlify.app/" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/sf_houzing" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>
            <Img src={Ecommerce} onClick={() => setModalVisible5(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible6}
              onOk={() => setModalVisible6(false)}
              onCancel={() => setModalVisible6(false)}
            >
              <ModalWrap>
                <h1 className="modaltitle" style={{ fontWeight: "700", fontSize: "45px" }}>
                  Countries API [Fetch vs Axios]
                </h1>
                <Img modal src={Fetch} />
                <ul>
                  <li>Developed simple application where to get all </li>
                </ul>
                <div>
                  <Link href="https://api-all-countries.netlify.app" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/sf_houzing" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>
            <Img src={Fetch} onClick={() => setModalVisible6(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img>
            <Modal
              centered
              keyboard
              width={1000}
              footer={null}
              visible={modalVisible7}
              onOk={() => setModalVisible7(false)}
              onCancel={() => setModalVisible7(false)}
            >
              <ModalWrap>
                <h1 className="modaltitle" style={{ fontWeight: "700", fontSize: "45px" }}>
                  Catering Food app
                </h1>
                <Img modal src={CaterWay} />
                <ul>
                  <li>Designed frontend by using ReactJS, HTML5, styled-components, JavaScript</li>
                  <li>Created reusable components to avoid unnecessary files</li>
                </ul>
                <div>
                  <Link href="https://caterway.netlify.app" target="blank">
                    <Button shape="round" type="primary" size="large">
                      Demo
                    </Button>
                  </Link>
                  <Link href="https://github.com/kholdarboev/caterway" target="blank">
                    <Button
                      style={{ marginLeft: "10px", background: "#25292F", color: "#fff" }}
                      shape="round"
                      size="large"
                      type="secondary"
                    >
                      Github
                    </Button>
                  </Link>
                </div>
              </ModalWrap>
            </Modal>
            <Img src={CaterWay} onClick={() => setModalVisible7(true)} />
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper img></Wrapper>
        </Wrapper>
      </Wrapper>
      <Wrapper title reveal>
        <Link href="https://github.com/kholdarboev?tab=repositories" target="blank">
          <Buttons>See All</Buttons>
        </Link>
      </Wrapper>
    </Container>
  );
}
